import { render, staticRenderFns } from "./ProductDetailScreen.vue?vue&type=template&id=168ab05e&"
import script from "./ProductDetailScreen.vue?vue&type=script&lang=js&"
export * from "./ProductDetailScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports